const truncateText = (textIn) => {
    const regex = new RegExp(/^(.{100}[^\s]*).*/);
    let truncatedString = textIn.replace(regex, '$1');
    truncatedString = truncatedString.replace(/\s+$/, '');
    return truncatedString;
};

export default truncateText;



// WEBPACK FOOTER //
// ./src/scripts/truncate-text.js